import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputFilePlaceholderFn = /* @__PURE__ */ createRecipe('input-file-placeholder', {}, [])

const inputFilePlaceholderVariantMap = {}

const inputFilePlaceholderVariantKeys = Object.keys(inputFilePlaceholderVariantMap)

export const inputFilePlaceholder = /* @__PURE__ */ Object.assign(memo(inputFilePlaceholderFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputFilePlaceholder',
  __getCompoundVariantCss__: inputFilePlaceholderFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputFilePlaceholderVariantKeys,
  variantMap: inputFilePlaceholderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputFilePlaceholderVariantKeys)
  },
  getVariantProps: inputFilePlaceholderFn.getVariantProps,
})